export default __webpack_public_path__ + "e72c270958429362d94d2e49d7e4f6a6.png";